import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

export const MessageUnreadCount = ({ 
  content = '', 
  color = 'black', 
  fontSize = '16px', 
  textAlign = 'center', 
  fontWeight = 'normal', 
  fontStyle = 'normal', 
  backgroundColor = 'transparent', 
  borderColor = 'transparent', 
  borderWidth = '', 
  borderStyle = '', 
  borderRadius = '4px',
  fontFamily = '',
  width = "",
  height = "auto",
  display="flex",
  alignItems="center",
justifyContent="center",
padding=""
  
}) => {
  // Don't render anything if content is 0, null, or undefined
  if (!content || content === 0) {
    return html``;
  }
  
  // Format the content to show "9+" for counts greater than 9
  const formattedContent = content > 9 ? '9+' : content;
  
  return html`
    <div
      style=${styleMap({ 
        color, 
        fontSize, 
        textAlign, 
        fontWeight, 
        fontStyle, 
        backgroundColor,
        borderColor, 
        borderWidth, 
        borderStyle,
        borderRadius,
        fontFamily,
        width,
        height,
        alignItems,
        justifyContent,
        display,
        padding
      })}
    >
      ${formattedContent}
    </div>
  `;
};

